export const RegExpEscape = (s:string) => {
	return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
};

export const classList = (...args:(string | boolean)[]) => {
    return args.filter(Boolean).join(' ');
};

export const toENEn = (str:string) => {
    return str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s:string) {
                return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
    });
};

/**
	 * 半全角カナ変換モジュール
	 * @return {[type]} [description]
	 * http://tomcky.hatenadiary.jp/entry/2014/06/21/134521
	 * マップ拡張
	  *console.log(kanaConverter.convertKanaToOneByte('アイウエオカキクケコkakikukekoサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヲン亜位鵜ァィゥェォッャュョガギグゲゴザジズゼゾダヂヅデドバビブベボばびぶべぼパピプペポ、。ー「」'));
	　*console.log(kanaConverter.convertKanaToTwoByte('ｱｲｳｴｵあいうえおｧｨｩｪｫｶｷｸｹｺｶﾞｷﾞｸﾞｹﾞｺﾞｻｼｽｾｿｻﾞｼﾞｽﾞｾﾞｿﾞﾀﾁﾂﾃﾄﾀﾞﾁﾞﾂﾞﾃﾞﾄﾞｯﾅﾆﾇﾈﾉnaninunenoﾊﾋﾌﾍﾎﾊﾞﾋﾞﾌﾞﾍﾞﾎﾞﾊﾟﾋﾟﾌﾟﾍﾟﾎﾟﾏﾐﾑﾒﾓﾔﾕﾖｬｭｮﾗﾘﾙﾚﾛﾜｦﾝ､｡ｰ｢｣'));
**/
export const kanaConverter = (()=>{
    

	  // マップ作成用関数
	  let createKanaMap = function(properties:string, values:string) {
	    let kanaMap:any = {};
	    // 念のため文字数が同じかどうかをチェックする(ちゃんとマッピングできるか)
	    if(properties.length === values.length) {
	      for(var i=0, len=properties.length; i<len; i++) {
	        let property= properties.charCodeAt(i),
	        value = values.charCodeAt(i);
	        kanaMap[property] = value;
	      }
	    }
	    return kanaMap;
	  };

	  // 全角から半角への変換用マップ
	  const m:any = createKanaMap(
	    'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヲンァィゥェォッャュョ、。ー「」',
	    'ｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜｦﾝｧｨｩｪｫｯｬｭｮ､｡ｰ｢｣'
	    );
	  // 半角から全角への変換用マップ
	  const mm:any = createKanaMap(
	    'ｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜｦﾝｧｨｩｪｫｯｬｭｮ､｡ｰ｢｣',
	    'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヲンァィゥェォッャュョ、。ー「」'
	    );

	  // 全角から半角への変換用マップ
	  const g:any = createKanaMap(
	    'ガギグゲゴザジズゼゾダヂヅデドバビブベボ',
	    'ｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾊﾋﾌﾍﾎ'
	    );
	  // 半角から全角への変換用マップ
	  const gg:any = createKanaMap(
	    'ｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾊﾋﾌﾍﾎ',
	    'ガギグゲゴザジズゼゾダヂヅデドバビブベボ'
	    );
	  
	  // 全角から半角への変換用マップ
	  const p:any = createKanaMap(
	    'パピプペポ',
	    'ﾊﾋﾌﾍﾎ'
	    );
	  // 半角から全角への変換用マップ
	  const pp:any = createKanaMap(
	    'ﾊﾋﾌﾍﾎ',
	    'パピプペポ'
	    );

	  const gMark:any = 'ﾞ'.charCodeAt(0),
	      pMark = 'ﾟ'.charCodeAt(0);

	   return {
	    /**
	     * 全角から半角への変換用関数
	     * @param  {[type]} str 変換対象文字列
	     * @return {[type]}     変換後文字列
	     */
	    convertKanaToOneByte : function(str:string) {
console.log("g",g);
            for(var i=0, len=str.length; i<len; i++) {
	        // 濁音もしくは半濁音文字
	        if(g.hasOwnProperty(str.charCodeAt(i)) || p.hasOwnProperty(str.charCodeAt(i))) {
	          // 濁音
	          if(g[str.charCodeAt(i)]) {
	            str = str.replace(str[i], String.fromCharCode(g[str.charCodeAt(i)])+String.fromCharCode(gMark));
	          }
	          // 半濁音
	          else if(p[str.charCodeAt(i)]) {
	            str = str.replace(str[i], String.fromCharCode(p[str.charCodeAt(i)])+String.fromCharCode(pMark));
	          }
	          else {
	            break;
	          }
	          // 文字列数が増加するため調整
	          i++;
	          len = str.length;
	        }
	        else {
	          if(m[str.charCodeAt(i)]) {
	            str = str.replace(str[i], String.fromCharCode(m[str.charCodeAt(i)]));
	          }
	        }
	      }
	      return str;
	    },
	    /**
	     * 半角から全角への変換用関数
	     * @param  {[type]} str 変換対象文字列
	     * @return {[type]}     変換後文字列
	     */
	    convertKanaToTwoByte : function(str:string) {
	    	for(var i=0, len=str.length; i<len; i++) {
	        // console.log(str[i]);
	        // 濁音もしくは半濁音文字
	        if(str.charCodeAt(i) === gMark || str.charCodeAt(i) === pMark) {
	          // 濁音
	          if(str.charCodeAt(i) === gMark && gg[str.charCodeAt(i-1)]) {
	            str = str.replace(str[i-1], String.fromCharCode(gg[str.charCodeAt(i-1)]))
	                     .replace(str[i], '');
	          }
	          // 半濁音
	          else if(str.charCodeAt(i) === pMark && pp[str.charCodeAt(i-1)]) {
	            str = str.replace(str[i-1], String.fromCharCode(pp[str.charCodeAt(i-1)]))
	                     .replace(str[i], '');
	          }
	          else {
	            break;
	          }
	          // 文字列数が減少するため調整
	          i--;
	          len = str.length;
	        }
	        else {
	          // １つ先の文字を見て濁音もしくは半濁音でないことを確認
	          if(mm[str.charCodeAt(i)] && str.charCodeAt(i+1) !== gMark && str.charCodeAt(i+1) !== pMark) {
	            str = str.replace(str[i], String.fromCharCode(mm[str.charCodeAt(i)]));
	          }
	        }
	      }
	    	return str;
	    }
	  };
	})();


// WEBPACK FOOTER //
// ./src/auto-suggest/src/functions.ts